module.exports = __webpack_public_path__ + "static/media/search.60707dda.gif";